module.exports = function (e) {
  var r = {};

  function t(n) {
    if (r[n]) return r[n].exports;
    var a = r[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
  }

  return t.m = e, t.c = r, t.d = function (e, r, n) {
    t.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: n
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, r) {
    if (1 & r && (e = t(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (t.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var a in e) {
      t.d(n, a, function (r) {
        return e[r];
      }.bind(null, a));
    }
    return n;
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.p = "", t(t.s = 0);
}([function (e, r, t) {
  e.exports = t(1);
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  });
  var n = l(t(2)),
      a = l(t(8)),
      o = t(11);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function s(e) {
    var r = e.style,
        t = e.className,
        a = e.id,
        l = e.transparent;
    return n.default.createElement("img", {
      src: function (e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];

        switch (e) {
          case "adyen":
            return (0, o.getFlagSvgUrl)("adyen", r);

          case "amazon":
            return (0, o.getBankSvgUrls)("amazon", r);

          case "amex":
            return (0, o.getFlagSvgUrl)("amex", r);

          case "aura":
            return (0, o.getFlagSvgUrl)("aura", r);

          case "bin":
            return (0, o.getFlagSvgUrl)("bin", r);

          case "cirrus":
            return (0, o.getFlagSvgUrl)("cirrus", r);

          case "diners":
            return (0, o.getFlagSvgUrl)("diners", r);

          case "direct_debit":
            return (0, o.getFlagSvgUrl)("direct_debit", r);

          case "discover":
            return (0, o.getFlagSvgUrl)("discover", r);

          case "ebay":
            return (0, o.getFlagSvgUrl)("ebay", r);

          case "elo":
            return (0, o.getFlagSvgUrl)("elo", r);

          case "eway":
            return (0, o.getFlagSvgUrl)("eway", r);

          case "hipercard":
            return (0, o.getFlagSvgUrl)("hipercard", r);

          case "jcb":
            return (0, o.getFlagSvgUrl)("jcb", r);

          case "maestro":
            return (0, o.getFlagSvgUrl)("maestro", r);

          case "mastercard":
            return (0, o.getFlagSvgUrl)("mastercard", r);

          case "paypal":
            return (0, o.getFacilitatorSvgUrl)("paypal", r);

          case "sage":
            return (0, o.getFlagSvgUrl)("sage", r);

          case "shopify":
            return (0, o.getFlagSvgUrl)("shopify", r);

          case "skrill_moneybookers":
            return (0, o.getFlagSvgUrl)("skrill_moneybookers", r);

          case "skrill":
            return (0, o.getFlagSvgUrl)("skrill", r);

          case "sodexo":
            return (0, o.getFlagSvgUrl)("sodexo", r);

          case "solo":
            return (0, o.getFlagSvgUrl)("solo", r);

          case "ticket":
            return (0, o.getFlagSvgUrl)("ticket", r);

          case "visa_electron":
            return (0, o.getFlagSvgUrl)("visa_electron", r);

          case "visa":
            return (0, o.getFlagSvgUrl)("visa", r);

          case "wallet":
            return (0, o.getFacilitatorSvgUrl)("wallet", r);

          case "western":
            return (0, o.getFlagSvgUrl)("western", r);

          case "wirecard":
            return (0, o.getFlagSvgUrl)("wirecard", r);

          case "worldpay":
            return (0, o.getFacilitatorSvgUrl)("worldpay", r);

          case "applepay":
            return (0, o.getFacilitatorSvgUrl)("applepay", r);

          case "bitcoin":
            return (0, o.getFacilitatorSvgUrl)("bitcoin", r);

          case "boleto":
            return (0, o.getBankSvgUrls)("boleto", r);

          case "cielo":
            return (0, o.getFacilitatorSvgUrl)("cielo", r);

          case "ebanx":
            return (0, o.getFacilitatorSvgUrl)("ebanx", r);

          case "elavon":
            return (0, o.getFacilitatorSvgUrl)("elavon", r);

          case "firstdata":
            return (0, o.getFacilitatorSvgUrl)("firstdata", r);

          case "getnet":
            return (0, o.getFacilitatorSvgUrl)("getnet", r);

          case "global":
            return (0, o.getFacilitatorSvgUrl)("global", r);

          case "googlepay":
            return (0, o.getFacilitatorSvgUrl)("googlepay", r);

          case "iugu":
            return (0, o.getFacilitatorSvgUrl)("iugu", r);

          case "mercadopago":
            return (0, o.getFacilitatorSvgUrl)("mercadopago", r);

          case "pagarme":
            return (0, o.getFacilitatorSvgUrl)("pagarme", r);

          case "pagseguro":
            return (0, o.getFacilitatorSvgUrl)("pagseguro", r);

          case "yapay":
            return (0, o.getFacilitatorSvgUrl)("yapay", r);

          case "adiq":
            return (0, o.getFacilitatorSvgUrl)("adiq", r);

          case "rede":
            return (0, o.getFacilitatorSvgUrl)("rede", r);

          case "stone":
            return (0, o.getFacilitatorSvgUrl)("stone", r);

          case "stelo":
            return (0, o.getFacilitatorSvgUrl)("stelo", r);

          case "paghiper":
            return (0, o.getFacilitatorSvgUrl)("paghiper", r);

          case "bb":
            return (0, o.getBankSvgUrls)("bb", r);

          case "bradesco":
            return (0, o.getBankSvgUrls)("bradesco", r);

          case "caixa":
            return (0, o.getBankSvgUrls)("caixa", r);

          case "hsbc":
            return (0, o.getBankSvgUrls)("hsbc", r);

          case "itau":
            return (0, o.getBankSvgUrls)("itau", r);

          case "santander":
            return (0, o.getBankSvgUrls)("santander", r);

          default:
            return (0, o.getUnknownSvg)("generic", r);
        }
      }(a, l),
      style: r,
      className: t,
      alt: a + " payment icon"
    });
  };

  s.propTypes = {
    style: a.default.object,
    className: a.default.string,
    id: a.default.string.isRequired,
    transparent: a.default.bool
  }, s.defaultProps = {
    transparent: !1,
    style: {},
    className: ""
  }, r.default = s;
}, function (e, r, t) {
  "use strict";

  e.exports = t(3);
}, function (e, r, t) {
  "use strict";
  /** @license React v16.4.2
   * react.production.min.js
   *
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var n = t(4),
      a = t(5),
      o = t(6),
      l = t(7),
      s = "function" == typeof Symbol && Symbol.for,
      i = s ? Symbol.for("react.element") : 60103,
      c = s ? Symbol.for("react.portal") : 60106,
      u = s ? Symbol.for("react.fragment") : 60107,
      g = s ? Symbol.for("react.strict_mode") : 60108,
      f = s ? Symbol.for("react.profiler") : 60114,
      p = s ? Symbol.for("react.provider") : 60109,
      v = s ? Symbol.for("react.context") : 60110,
      d = s ? Symbol.for("react.async_mode") : 60111,
      y = s ? Symbol.for("react.forward_ref") : 60112;
  s && Symbol.for("react.timeout");
  var b = "function" == typeof Symbol && Symbol.iterator;

  function m(e) {
    for (var r = arguments.length - 1, t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 0; n < r; n++) {
      t += "&args[]=" + encodeURIComponent(arguments[n + 1]);
    }

    a(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", t);
  }

  var h = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  };

  function S(e, r, t) {
    this.props = e, this.context = r, this.refs = o, this.updater = t || h;
  }

  function _() {}

  function U(e, r, t) {
    this.props = e, this.context = r, this.refs = o, this.updater = t || h;
  }

  S.prototype.isReactComponent = {}, S.prototype.setState = function (e, r) {
    "object" != typeof e && "function" != typeof e && null != e && m("85"), this.updater.enqueueSetState(this, e, r, "setState");
  }, S.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  }, _.prototype = S.prototype;
  var k = U.prototype = new _();
  k.constructor = U, n(k, S.prototype), k.isPureReactComponent = !0;
  var F = {
    current: null
  },
      w = Object.prototype.hasOwnProperty,
      x = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function O(e, r, t) {
    var n = void 0,
        a = {},
        o = null,
        l = null;
    if (null != r) for (n in void 0 !== r.ref && (l = r.ref), void 0 !== r.key && (o = "" + r.key), r) {
      w.call(r, n) && !x.hasOwnProperty(n) && (a[n] = r[n]);
    }
    var s = arguments.length - 2;
    if (1 === s) a.children = t;else if (1 < s) {
      for (var c = Array(s), u = 0; u < s; u++) {
        c[u] = arguments[u + 2];
      }

      a.children = c;
    }
    if (e && e.defaultProps) for (n in s = e.defaultProps) {
      void 0 === a[n] && (a[n] = s[n]);
    }
    return {
      $$typeof: i,
      type: e,
      key: o,
      ref: l,
      props: a,
      _owner: F.current
    };
  }

  function j(e) {
    return "object" == typeof e && null !== e && e.$$typeof === i;
  }

  var P = /\/+/g,
      R = [];

  function E(e, r, t, n) {
    if (R.length) {
      var a = R.pop();
      return a.result = e, a.keyPrefix = r, a.func = t, a.context = n, a.count = 0, a;
    }

    return {
      result: e,
      keyPrefix: r,
      func: t,
      context: n,
      count: 0
    };
  }

  function T(e) {
    e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > R.length && R.push(e);
  }

  function $(e, r, t, n) {
    var a = typeof e;
    "undefined" !== a && "boolean" !== a || (e = null);
    var o = !1;
    if (null === e) o = !0;else switch (a) {
      case "string":
      case "number":
        o = !0;
        break;

      case "object":
        switch (e.$$typeof) {
          case i:
          case c:
            o = !0;
        }

    }
    if (o) return t(n, e, "" === r ? "." + C(e, 0) : r), 1;
    if (o = 0, r = "" === r ? "." : r + ":", Array.isArray(e)) for (var l = 0; l < e.length; l++) {
      var s = r + C(a = e[l], l);
      o += $(a, s, t, n);
    } else if ("function" == typeof (s = null === e || void 0 === e ? null : "function" == typeof (s = b && e[b] || e["@@iterator"]) ? s : null)) for (e = s.call(e), l = 0; !(a = e.next()).done;) {
      o += $(a = a.value, s = r + C(a, l++), t, n);
    } else "object" === a && m("31", "[object Object]" == (t = "" + e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : t, "");
    return o;
  }

  function C(e, r) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var r = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + ("" + e).replace(/[=:]/g, function (e) {
        return r[e];
      });
    }(e.key) : r.toString(36);
  }

  function B(e, r) {
    e.func.call(e.context, r, e.count++);
  }

  function q(e, r, t) {
    var n = e.result,
        a = e.keyPrefix;
    e = e.func.call(e.context, r, e.count++), Array.isArray(e) ? A(e, n, t, l.thatReturnsArgument) : null != e && (j(e) && (r = a + (!e.key || r && r.key === e.key ? "" : ("" + e.key).replace(P, "$&/") + "/") + t, e = {
      $$typeof: i,
      type: e.type,
      key: r,
      ref: e.ref,
      props: e.props,
      _owner: e._owner
    }), n.push(e));
  }

  function A(e, r, t, n, a) {
    var o = "";
    null != t && (o = ("" + t).replace(P, "$&/") + "/"), r = E(r, o, n, a), null == e || $(e, "", q, r), T(r);
  }

  var M = {
    Children: {
      map: function map(e, r, t) {
        if (null == e) return e;
        var n = [];
        return A(e, n, null, r, t), n;
      },
      forEach: function forEach(e, r, t) {
        if (null == e) return e;
        r = E(null, null, r, t), null == e || $(e, "", B, r), T(r);
      },
      count: function count(e) {
        return null == e ? 0 : $(e, "", l.thatReturnsNull, null);
      },
      toArray: function toArray(e) {
        var r = [];
        return A(e, r, null, l.thatReturnsArgument), r;
      },
      only: function only(e) {
        return j(e) || m("143"), e;
      }
    },
    createRef: function createRef() {
      return {
        current: null
      };
    },
    Component: S,
    PureComponent: U,
    createContext: function createContext(e, r) {
      return void 0 === r && (r = null), (e = {
        $$typeof: v,
        _calculateChangedBits: r,
        _defaultValue: e,
        _currentValue: e,
        _currentValue2: e,
        _changedBits: 0,
        _changedBits2: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: p,
        _context: e
      }, e.Consumer = e;
    },
    forwardRef: function forwardRef(e) {
      return {
        $$typeof: y,
        render: e
      };
    },
    Fragment: u,
    StrictMode: g,
    unstable_AsyncMode: d,
    unstable_Profiler: f,
    createElement: O,
    cloneElement: function cloneElement(e, r, t) {
      (null === e || void 0 === e) && m("267", e);
      var a = void 0,
          o = n({}, e.props),
          l = e.key,
          s = e.ref,
          c = e._owner;

      if (null != r) {
        void 0 !== r.ref && (s = r.ref, c = F.current), void 0 !== r.key && (l = "" + r.key);
        var u = void 0;

        for (a in e.type && e.type.defaultProps && (u = e.type.defaultProps), r) {
          w.call(r, a) && !x.hasOwnProperty(a) && (o[a] = void 0 === r[a] && void 0 !== u ? u[a] : r[a]);
        }
      }

      if (1 == (a = arguments.length - 2)) o.children = t;else if (1 < a) {
        u = Array(a);

        for (var g = 0; g < a; g++) {
          u[g] = arguments[g + 2];
        }

        o.children = u;
      }
      return {
        $$typeof: i,
        type: e.type,
        key: l,
        ref: s,
        props: o,
        _owner: c
      };
    },
    createFactory: function createFactory(e) {
      var r = O.bind(null, e);
      return r.type = e, r;
    },
    isValidElement: j,
    version: "16.4.2",
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
      ReactCurrentOwner: F,
      assign: n
    }
  },
      N = {
    default: M
  },
      I = N && M || N;
  e.exports = I.default ? I.default : I;
}, function (e, r, t) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var n = Object.getOwnPropertySymbols,
      a = Object.prototype.hasOwnProperty,
      o = Object.prototype.propertyIsEnumerable;
  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var r = {}, t = 0; t < 10; t++) {
        r["_" + String.fromCharCode(t)] = t;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(r).map(function (e) {
        return r[e];
      }).join("")) return !1;
      var n = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        n[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, r) {
    for (var t, l, s = function (e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }(e), i = 1; i < arguments.length; i++) {
      for (var c in t = Object(arguments[i])) {
        a.call(t, c) && (s[c] = t[c]);
      }

      if (n) {
        l = n(t);

        for (var u = 0; u < l.length; u++) {
          o.call(t, l[u]) && (s[l[u]] = t[l[u]]);
        }
      }
    }

    return s;
  };
}, function (e, r, t) {
  "use strict";

  e.exports = function (e, r, t, n, a, o, l, s) {
    if (!e) {
      var i;
      if (void 0 === r) i = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var c = [t, n, a, o, l, s],
            u = 0;
        (i = new Error(r.replace(/%s/g, function () {
          return c[u++];
        }))).name = "Invariant Violation";
      }
      throw i.framesToPop = 1, i;
    }
  };
}, function (e, r, t) {
  "use strict";

  e.exports = {};
}, function (e, r, t) {
  "use strict";

  function n(e) {
    return function () {
      return e;
    };
  }

  var a = function a() {};

  a.thatReturns = n, a.thatReturnsFalse = n(!1), a.thatReturnsTrue = n(!0), a.thatReturnsNull = n(null), a.thatReturnsThis = function () {
    return this;
  }, a.thatReturnsArgument = function (e) {
    return e;
  }, e.exports = a;
}, function (e, r, t) {
  e.exports = t(9)();
}, function (e, r, t) {
  "use strict";

  var n = t(10);

  function a() {}

  e.exports = function () {
    function e(e, r, t, a, o, l) {
      if (l !== n) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }

    function r() {
      return e;
    }

    e.isRequired = e;
    var t = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: r,
      element: e,
      instanceOf: r,
      node: e,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r
    };
    return t.checkPropTypes = a, t.PropTypes = t, t;
  };
}, function (e, r, t) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.getFlagSvgUrl = function (e) {
    var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? "_transparent" : "";
    return {
      adyen: n + "/adyen" + r + ".svg",
      amex: n + "/amex" + r + ".svg",
      aura: n + "/aura" + r + ".svg",
      bin: n + "/bin" + r + ".svg",
      boleto: n + "/boleto" + r + ".svg",
      cirrus: n + "/cirrus" + r + ".svg",
      credit_card: n + "/credit-card" + r + ".svg",
      diners: n + "/diners" + r + ".svg",
      direct_debit: n + "/direct_debit" + r + ".svg",
      discover: n + "/discover" + r + ".svg",
      ebay: n + "/ebay" + r + ".svg",
      elo: n + "/elo" + r + ".svg",
      eway: n + "/eway" + r + ".svg",
      hipercard: n + "/hipercard" + r + ".svg",
      jcb: n + "/jcb" + r + ".svg",
      maestro: n + "/maestro" + r + ".svg",
      mastercard: n + "/mastercard" + r + ".svg",
      sage: n + "/sage" + r + ".svg",
      shopify: n + "/shopify" + r + ".svg",
      skrill: n + "/skrill" + r + ".svg",
      skrill_moneybookers: n + "/skrill_moneybookers" + r + ".svg",
      sodexo: n + "/sodexo" + r + ".svg",
      solo: n + "/solo" + r + ".svg",
      ticket: n + "/ticket" + r + ".svg",
      visa: n + "/visa" + r + ".svg",
      visa_electron: n + "/visa_electron" + r + ".svg",
      western: n + "/western" + r + ".svg",
      wirecard: n + "/wirecard" + r + ".svg"
    }[e];
  }, r.getBankSvgUrls = function (e) {
    var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? "_transparent" : "";
    return {
      boleto: n + "/boleto" + r + ".svg",
      bb: n + "/bb" + r + ".svg",
      bradesco: n + "/bradesco" + r + ".svg",
      caixa: n + "/caixa" + r + ".svg",
      hsbc: n + "/hsbc" + r + ".svg",
      itau: n + "/itau" + r + ".svg",
      santander: n + "/santander" + r + ".svg"
    }[e];
  }, r.getFacilitatorSvgUrl = function (e) {
    var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? "_transparent" : "";
    return {
      amazon: n + "/amazon" + r + ".svg",
      adiq: n + "/adiq" + r + ".svg",
      applepay: n + "/applepay" + r + ".svg",
      bitcoin: n + "/bitcoin" + r + ".svg",
      ebanx: n + "/ebanx" + r + ".svg",
      firstdata: n + "/firstdata" + r + ".svg",
      wallet: n + "/wallet" + r + ".svg",
      paypal: n + "/paypal" + r + ".svg",
      cielo: n + "/cielo" + r + ".svg",
      global: n + "/global" + r + ".svg",
      googlepay: n + "/googlepay" + r + ".svg",
      iugu: n + "/iugu" + r + ".svg",
      mercadopago: n + "/mercadopago" + r + ".svg",
      pagarme: n + "/pagarme" + r + ".svg",
      pagseguro: n + "/pagseguro" + r + ".svg",
      paghiper: n + "/paghiper" + r + ".png",
      rede: n + "/rede" + r + ".svg",
      stelo: n + "/stelo" + r + ".svg",
      stone: n + "/stone" + r + ".svg",
      elavon: n + "/elavon" + r + ".svg",
      getnet: n + "/getnet" + r + ".png",
      worldpay: n + "/worldpay" + r + ".svg",
      yapay: n + "/yapay" + r + ".svg"
    }[e];
  }, r.getUnknownSvg = function (e) {
    var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return {
      generic: n + "/generic" + (r ? "_transparent" : "") + ".svg"
    }[e];
  };
  var n = "https://s3-sa-east-1.amazonaws.com/azpay-checkout/payment-methods";
}]);